import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Briefcase } from 'lucide-react';
import './Enroll.css';

const Enroll = () => {
    return (
        <div className="enrollment-container">
            <div className="enrollment-wrapper">
                <div className="enrollment-card career-coach">
                    <div className="card-content">
                        <BookOpen className="card-icon" size={64} />
                        <h2>Career Coaches</h2>
                        <p>Career coaches are dedicated professionals who provide personalized guidance to help students and working professionals navigate their career paths.</p>

                        <div className="coach-duties">
                            <h3>Key Responsibilities:</h3>
                            <ul>
                                <li>Assess individual strengths and interests</li>
                                <li>Provide career path recommendations</li>
                                <li>Help develop professional skills</li>
                                <li>Offer job market insights</li>
                                <li>Support personal and professional growth</li>
                            </ul>
                        </div>

                        <Link to="/career-coach-enrollment" className="join-button">
                            Join as Career Coach
                        </Link>
                    </div>
                </div>

                <div className="enrollment-card professional">
                    <div className="card-content">
                        <Briefcase className="card-icon" size={64} />
                        <h2>Professionals</h2>
                        <p>Experienced professionals play a crucial role in bridging the gap between education and real-world career opportunities.</p>

                        <div className="professional-roles">
                            <h3>Your Impact:</h3>
                            <ul>
                                <li>Share industry-specific insights</li>
                                <li>Mentor aspiring talents</li>
                                <li>Provide real-world career advice</li>
                                <li>Contribute to skill development</li>
                                <li>Create networking opportunities</li>
                            </ul>
                        </div>

                        <Link to="/professional-enrollment" className="join-button">
                            Join as Professional
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Enroll;